import { FREQUENCY_ANNUALLY } from '../constants/constants';
import { EMPTY_NEXT_PAYMENT_DATE } from '../constants/payment';

export const getAllPolicyHolders = ({ petDetails }) => {
  const uniquePolicyHolders = [];
  return petDetails?.reduce((acc, petDetail) => {
    const {
      PolicyDetails: { PolicyHolder, PolicyNo: policyNumber }
    } = petDetail;

    const { title, firstName, lastName, dateOfBirth, street, suburb, postcode, email, phoneHome, phoneMobile } =
      PolicyHolder;

    const uniqueString = `
      ${title}
      ${firstName}
      ${lastName}
      ${dateOfBirth}
      ${street}
      ${suburb}
      ${postcode}
      ${email}
      ${phoneHome}
      ${phoneMobile}
      ${policyNumber}
      `;

    if (uniquePolicyHolders.indexOf(uniqueString) === -1) {
      uniquePolicyHolders.push(uniqueString);
      acc.push({ ...PolicyHolder, policyNumber });
    }
    return acc;
  }, []);
};

export const dateToReadable = (date, { longMonth = true } = {}) => {
  if (!date) return '';
  const d = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  return new Intl.DateTimeFormat('en-AU', {
    day: 'numeric',
    month: longMonth ? 'long' : 'short', // long → “January”，short → “Jan”
    year: 'numeric'
  }).format(d);
};

export const formatCurrency = (amount, locale = 'en-AU', currency = 'AUD') =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: amount === 0 ? 0 : 2 // 0 → “$0”，others value → “$123.45”
  }).format(amount);

export const getPolicyHolderName = (petDetails) => {
  const holder = petDetails[0]?.PolicyDetails?.PolicyHolder;
  return holder ? `${holder.firstName}` : '';
};

export const getNextPaymentDateText = ({ nextPaymentDate, frequencyKey, formatDate }) => {
  const hasNextPaymentDate = nextPaymentDate && nextPaymentDate.slice(0, 10) !== EMPTY_NEXT_PAYMENT_DATE;

  if (hasNextPaymentDate) {
    return formatDate(new Date(nextPaymentDate));
  }

  return frequencyKey === FREQUENCY_ANNUALLY ? 'Next policy period' : 'N/A';
};
